import { useState } from 'react';
import { supabase } from '@/client/lib/supabase';

export function useAuth() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function signIn(email: string, password: string): Promise<boolean> {
    setLoading(true);
    setError(null);
    try {
      const { error: authError } = await supabase.auth.signInWithPassword({ email, password });
      if (authError) {
        setError(authError.message);
        return false;
      }
      return true;
    } finally {
      setLoading(false);
    }
  }

  async function signUp(email: string, password: string): Promise<boolean> {
    setLoading(true);
    setError(null);
    try {
      const { error: authError } = await supabase.auth.signUp({ email, password });
      if (authError) {
        setError(authError.message);
        return false;
      }
      return true;
    } finally {
      setLoading(false);
    }
  }

  async function signOut(): Promise<void> {
    await supabase.auth.signOut();
  }

  async function sendPasswordResetEmail(email: string): Promise<boolean> {
    setLoading(true);
    setError(null);
    try {
      const { error: authError } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/reset-password`,
      });
      if (authError) {
        setError(authError.message);
        return false;
      }
      return true;
    } finally {
      setLoading(false);
    }
  }

  async function updatePassword(newPassword: string): Promise<boolean> {
    setLoading(true);
    setError(null);
    try {
      const { error: authError } = await supabase.auth.updateUser({ password: newPassword });
      if (authError) {
        setError(authError.message);
        return false;
      }
      return true;
    } finally {
      setLoading(false);
    }
  }

  return { signIn, signUp, signOut, sendPasswordResetEmail, updatePassword, loading, error, setError };
}
